const loadScreen = document.getElementById('loadScreen');
// Only set background image if user is not logged in (no a9.authData in sessionStorage)
const isLoggedIn = !!sessionStorage.getItem('a9.authData');

const positionAligner = document.createElement('div');
positionAligner.className = 'position-aligner';

const videoWrap = document.createElement('div');
videoWrap.className = 'video-wrap';

videoWrap.style.display = 'flex';
videoWrap.style.alignItems = 'center';
videoWrap.style.justifyContent = 'center';
videoWrap.style.width = '100%';
videoWrap.style.height = '100%';

videoWrap.id = 'place-loading-animation-here';

const titleLines = document.createElement('div');
titleLines.className = 'title-lines';

const line1 = document.createElement('div');
line1.className = 'line1';
line1.style.height = '40px';

const line2 = document.createElement('div');
line2.className = 'line2';

titleLines.appendChild(line1);
titleLines.appendChild(line2);
positionAligner.appendChild(videoWrap);
positionAligner.appendChild(titleLines);
loadScreen.appendChild(positionAligner);

// Insert GN_Logo.svg at the bottom right of the loading page

if (!isLoggedIn) {
    const logo = document.createElement('img');
    logo.src = 'images/GN_Logo.svg';
    logo.alt = 'GN Logo';
    logo.style.position = 'absolute';
    logo.style.bottom = '20px';
    logo.style.right = '20px';
    logo.style.zIndex = '10';
    loadScreen.appendChild(logo);
}
